<template>
  <v-container grid-list-xl class="pa-2">
    <v-row>
      <v-col cols="12" sm="12" md="8" lg="8">
        <m-info
          border
          color="#014224"
          :title="`Selamat Datang ` + current_user.name"
          icon="mdi-account"
          :mdIcon="2"
          :mdInfo="10"
          :lgIcon="2"
          :lgInfo="10"
          :xlIcon="2"
          :xlInfo="10"
        ></m-info>
      </v-col>
      <v-col cols="12" sm="12" md="4" lg="4">
        <m-info
          border
          button
          color="#014224"
          title="Hotline"
          icon="mdi-whatsapp"
          :mdIcon="2"
          :mdInfo="10"
          :lgIcon="2"
          :lgInfo="10"
          :xlIcon="2"
          :xlInfo="10"
          emitButton="toWA"
          @toWA="toWA"
        ></m-info>
      </v-col>
    </v-row>
    <div class="title primary--text">Informasi Terkini</div>
    <br />
    <v-row wrap>
      <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="my-0 py-0">
        <v-alert border="top" colored-border type="info" elevation="2" dismissible v-for="info in items" :key="info.id">
          <p class="font-weight-bold my-0 py-0">{{ info.judul }}</p>
          <div class="my-0 py-0" v-html="info.keterangan"></div>
        </v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      items: [],

      page: null,
      cp: 1
    };
  },
  computed: {
    headers() {
      const a = [{ text: "", align: "left", value: "" }, { text: "", align: "left", value: "" }, { text: "", align: "left", value: "" }, { text: "", sortable: false }];
      return a;
    }
  },
  activated() {
    this.load();
  },
  methods: {
    load() {
      return this.$store
        .dispatch("pengumuman/pengumumanku", {
          params: {
            page: this.cp,
            s: this.textSearch,
            tahun: this.tahun
          }
        })
        .then(res => {
          this.page = res;
          this.items = res.data;
        })
        .catch(e => e);
    },
    toWA() {
      // window.open("www.google.com", "_blank");
    }
  },
  watch: {}
};
</script>
